'use es6';

import BasicInterstitial from '../BasicInterstitial';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackCompleteInterstitial = ({
  buttonI18n = 'learningCenter.tracks.interstitials.backToTracks',
  buttonLink = '/',
  hideButton = false
} = {}) => /*#__PURE__*/_jsx(BasicInterstitial, {
  buttonI18n: buttonI18n,
  buttonLink: buttonLink,
  buttonUse: "primary",
  headingI18n: "learningCenter.tracks.interstitials.trackComplete",
  hideButton: hideButton,
  pictogramName: "CelebrationSuccess",
  subheadingI18n: "learningCenter.tracks.interstitials.trackCompleteSubheading"
});
export default TrackCompleteInterstitial;